module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/home-slides/ig-02-60c352a16967400df84701575d69592a.jpg";